var ctx;
var resizeId;
var myChartLog 	= "";
var has_focus 	= true;
var rcnt 		= 0;


window.lineChart = function(canvasElId, dataUrl, LWListener = null){
	
    ctx = document.getElementById("myChart_log").getContext("2d");
	
    Chart.defaults.global.legend.labels.usePointStyle = true;
    Chart.defaults.line.spanGaps = false;
	
    /** Initial load  graph*/
    showGraph(ctx, dataUrl);
	has_focus = true;
    resizeGraph();
	
	/** Listen for an event and re-render the chart */
	if(LWListener){
		Livewire.on(LWListener, function (){
			showGraph(ctx, dataUrl);
		})
	}
	
	/** Button for last week, 24-hour & hour */
	$("#"+canvasElId).parents(".gridbox").find(".hdrnav").on('click','.chHour',function(e){
		e.preventDefault();
		
		var thisEl = $(this);
		$('.hdrnav .dotBtn').removeClass('do');
		thisEl.addClass('do');
		$('.myChart_log_box h3 i').html(" \\ " + thisEl.attr('title'));
		
		graphUnit = "minute";
		graphMode	= 0;
		Chart.defaults.global.animation.duration = 1000;
		showGraphSpecific(ctx, dataUrl, graphUnit, graphMode);
		
		return false;
	});
	
	$("#"+canvasElId).parents(".gridbox").find(".hdrnav").on('click','.chDay',function(e){
		e.preventDefault();
		
		var thisEl = $(this);
		$('.hdrnav .dotBtn').removeClass('do');
		thisEl.addClass('do');
		$('.myChart_log_box h3 i').html(" \\ " + thisEl.attr('title'));
		
		graphUnit = "hour";
		graphMode	= 1;
		Chart.defaults.global.animation.duration = 1000;
		showGraphSpecific(ctx, dataUrl, graphUnit, graphMode);
		
		return false;
	});
	
	$("#"+canvasElId).parents(".gridbox").find(".hdrnav").on('click','.chWeek',function(e){
		e.preventDefault();
		
		var thisEl = $(this);
		$('.hdrnav .dotBtn').removeClass('do');
		thisEl.addClass('do');
		$('.myChart_log_box h3 i').html(" \\ " + thisEl.attr('title'));
		
		graphUnit = "day";
		graphMode	= 2;
		Chart.defaults.global.animation.duration = 1000;
		showGraphSpecific(ctx, dataUrl, graphUnit, graphMode);
		
		return false;
	});
	
	$(window).resize(function() {
		resizeGraph();
	})
}



/** options for the call home graph*/
var options = {
	responsive: true,
	maintainAspectRatio: false,
	legend: {
        display     : true,
        position    : 'bottom',
        align       : 'start' ,
        labels      : {
            fontColor   : 'grey',
            fontSize    : 11,
        }
	},
	tooltips: {
        mode    : 'point',
        custom  : function(tooltip) {
            if (!tooltip) return;
            tooltip.displayColors = false;
        },
        callbacks: {
            title: function(tooltipItem, data) {
                
                var currLabel 	= tooltipItem[0].xLabel;
                var newLabel 	= '';
                var unit 		= options.scales.xAxes[0].time.unit;
                
                if(unit == 'day'){
                    newLabel = moment(currLabel, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
                }
                if(unit == 'hour'){
                    newLabel  = moment(currLabel, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY hA');
                    newLabel += ' - ' + moment(currLabel, 'YYYY-MM-DD HH:mm:ss').add(1, 'hour').format('hA');
                }
                if(unit == 'minute'){
                    newLabel  = moment(currLabel, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY h:mmA');
                    newLabel += ' - ' + moment(currLabel, 'YYYY-MM-DD HH:mm:ss').add(1, 'minute').format('h:mmA');
                }
                /*
                    day hour minute
                */
                
                return newLabel;
            },
            label: function(tooltipItem, data) {
                
                var label = data.datasets[tooltipItem.datasetIndex].label;																
                if (label) {
                        label += ' called home ' + tooltipItem.yLabel + 'x';
                }
				
                return label;
            }
        }
	},
	layout: {
        padding: {
            left    : 0,
            right   : 20,
            top     : 20,
            bottom  : 5
        }
	},
	scales: {
		xAxes: [{
			type: 'time',
			time: {
				unit: 'day',
			},
			display: true,
			ticks: {
				major: {
					fontStyle: 'bold',
					fontColor: 'grey'
				},
				fontColor: 'grey'
			},
			gridLines: {
					color: "rgba(255, 255, 255, 1)",
			}
		}],
		yAxes: [{
			display: true,
			scaleLabel: {
				display		: true,
				labelString	: 'Calls',
				fontStyle	: 'bold',
				fontColor	: 'grey'
			},
			scaleFontColor: 'grey',
			gridLines: {
					color: "rgba(255, 255, 255, 1)",
			},
			ticks: {
                min: 0,
                /*max: 5760,*/
                beginAtZero: true,
                userCallback: function(label, index, labels) {
                    if (Math.floor(label) === label) {
                        return label;
                    }
                }
			}
		}]
	}
};


function showGraphSpecific(ctx, dataUrl, unit, mode, loader = true){
	if(has_focus == true){
		options.scales.xAxes[0].time.unit = unit;
		
		if(mode == 0){
			options.scales.xAxes[0].ticks = {
				autoSkip: true,
				maxTicksLimit: 6
			};
		}
		
		if(loader == true){ $('.myChart_log_box .loader').show(); }
		showGraph(ctx, dataUrl, "chChartMode=" + mode, function(){
			if(loader == true){ $('.myChart_log_box .loader').fadeOut('slow'); }
		});
	}
}


function showGraph(ctx, dataUrl, senddata = "", callback = null){
	if(ctx != undefined){
		
		axios.get(dataUrl + "?" + senddata)
			.then(function (response) {
				
				if(myChartLog == "" || response.data.length != myChartLog.data.datasets.length){
					// add call home chart
					ctx = document.getElementById("myChart_log").getContext("2d");
					
					myChartLog = new Chart(ctx,{
							type: 'line',
							data: {
								datasets: response.data
							},
							options: options
					});
					
				}else{
                    
					// check for toggled lables before updating data and labels accordingly
					for(var i=0; i<myChartLog.data.datasets.length; i++) {
						if (!myChartLog.isDatasetVisible(i)) {
							myChartLog.data.datasets[i] = response.data[i];
							myChartLog.data.datasets[i].hidden = true;
						}else{
							myChartLog.data.datasets[i] = response.data[i];
							myChartLog.data.datasets[i].hidden = false;
						}
					}
					
					// update call home chart
					myChartLog.options = options;
					myChartLog.update();
				}
				
				if(callback){callback();}
			})
			.catch(function(error){
				if(error.response && (error.response.status === 401 || error.response.status === 419)){
					window.location.href = "/login";
				}else{
					if(error.response && (error.response.status === 401 || error.response.status === 419)){
						window.location.href = "/login";
					}
				}
			});
	}
}


function resizeGraph(){
    clearTimeout(resizeId);
    resizeId = setTimeout(function(){
		if(ctx != undefined){
			var marg = 20;
			if(rcnt == 0){
				marg = 30;
				rcnt++;
			}
			var newLcHeight = $('.myChart_log_box').height() - marg;
			$('#myChart_log').height(newLcHeight);
		}
	}, 10);
}
